import { useSelector } from "react-redux";
import { PopupState } from "./slice";

export const usePopupState = () => {
    return useSelector(
        (state: { popup: PopupState }) => state
    );
};
